import Vue from 'vue'
import App from './App.vue'
import './plugins/ant-design-vue.js'
import router from './router'
import store from './store'

Vue.config.productionTip = false
console.log(process.env);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
